import { KPIindicator } from "./KPIindicator.model";
import { chartHeader } from "./chartHeader";

export class LeadingIndicator {

    data:KPIindicator[]
    header:chartHeader[];
    show_launch_kpi: boolean;

    constructor() {
        this.data = [];
        this.header = [];
        this.show_launch_kpi = true;
    }

}